import {
  FETCH_VEHICLES_DATA,
  FETCH_VEHICLES_SUCCESS,
  FETCH_VEHICLES_FAILURE,
} from "./actionTypes";

export const fetchVehiclesData = (vehicleId) => ({
  type: FETCH_VEHICLES_DATA,
  vehicleId: vehicleId
});

export const fetchVehiclesSuccess = (data) => ({
  type: FETCH_VEHICLES_SUCCESS,
  payload: data,
});

export const fetchVehiclesFailure = (error) => ({
  type: FETCH_VEHICLES_FAILURE,
  payload: error,
});
